import React from 'react';
import { Avatar } from '@material-ui/core';

function Logo(props) {
  return (
    <Avatar src="/static/1000containers-logo-white.svg" {...props} />
  );
}

export default Logo;
